import { render, staticRenderFns } from "./VideoMcpViewer.vue?vue&type=template&id=e2b83aae&"
import script from "./VideoMcpViewer.vue?vue&type=script&lang=js&"
export * from "./VideoMcpViewer.vue?vue&type=script&lang=js&"
import style0 from "./VideoMcpViewer.vue?vue&type=style&index=0&id=e2b83aae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports